module.exports = __webpack_public_path__ + "static/media/03-case.6c3cb286.png";